<template>
    <div class="wizard-settings">
        <design-2021-apprentice-multistep-form-wizard-form-header-component
            :title="$t('testcenter.assign')"
            :description="description">
        </design-2021-apprentice-multistep-form-wizard-form-header-component>

        <div
            class="sk-cube-grid"
            v-if="isLoading">
            <div class="sk-cube sk-cube1"></div>
            <div class="sk-cube sk-cube2"></div>
            <div class="sk-cube sk-cube3"></div>
            <div class="sk-cube sk-cube4"></div>
            <div class="sk-cube sk-cube5"></div>
            <div class="sk-cube sk-cube6"></div>
            <div class="sk-cube sk-cube7"></div>
            <div class="sk-cube sk-cube8"></div>
            <div class="sk-cube sk-cube9"></div>
        </div>

        <div
            class="errors"
            v-if="hasError">
            <b-alert
                class="test-select-error"
                show
                variant="danger">
                {{
                    $t('testcenter.no_selection', {
                        type: lasGroupsOrStudents === 'las' ? $t('testcenter.groups') : $t('testcenter.students'),
                    })
                }}
            </b-alert>
        </div>

        <b-form-radio-group
            class="apprentice-radiobutton students-groups-choice-group"
            id="las-or-students"
            v-if="groupsExist"
            v-model="lasGroupsOrStudents"
            @change="clearSelectedGroupAndStudents">
            <b-form-radio value="las">{{ $t('testcenter.by_group') }}</b-form-radio>
            <b-form-radio value="students">{{ $t('testcenter.by_student') }}</b-form-radio>
        </b-form-radio-group>

        <div
            class="las-main-groups"
            v-if="lasGroupsOrStudents === 'las' && groupsExist">
            <design-2021-apprentice-picklist-component
                class="groups-picklist"
                v-if="lasGroups.length > 0"
                v-model="lasGroups"
                :enable-search="true"
                key="las-groups"
                :available-label="$t('multistep.available_groups')"
                data-key="id"
                :selected-label="$t('multistep.selected_groups')"
                @update="updateSelectedGroups">
            </design-2021-apprentice-picklist-component>

            <design-2021-apprentice-picklist-component
                class="main-groups-picklist"
                v-if="lasMainGroups.length > 0"
                v-model="lasMainGroups"
                :enable-search="true"
                key="main-groups"
                :available-label="$t('multistep.available_main_groups')"
                data-key="id"
                :selected-label="$t('multistep.selected_main_groups')"
                @update="updateSelectedMainGroups">
            </design-2021-apprentice-picklist-component>
        </div>

        <div
            class="students"
            v-if="lasGroupsOrStudents === 'students' && students.length > 0">
            <design-2021-apprentice-picklist-component
                class="students-picklist"
                v-model="students"
                :enable-search="true"
                :available-label="$t('testcenter.available_students')"
                name-key="full_name"
                data-key="id"
                :selected-label="$t('testcenter.selected_students')"
                @update="updateSelectedStudents">
            </design-2021-apprentice-picklist-component>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
    name: 'design-2021-test-center-issuing-wizard-settings-component',
    props: {
        value: Object,
        required: true,
    },
    data() {
        return {
            description: this.$t('testcenter.description_send_out_choose_students'),
            lasGroups: [],
            lasMainGroups: [],
            students: [],
            groups: {
                las_groups: this.value.las_groups,
                main_groups: this.value.main_groups,
                students: this.value.students,
            },
            selectedLasGroups: null,
            selectedMainGroups: null,
            lasGroupsOrStudents: 'students',
            hasError: false,
            isLoading: false,
        };
    },

    mounted() {
        this.isLoading = true;
        this.axios.get(this.routes.getLasGroups()).then((response) => {
            this.lasGroups = response.data;
            if (this.lasGroups.length) {
                this.lasGroupsOrStudents = 'las';
            }
        });

        this.axios.get(this.routes.getLasMainGroups()).then((response) => {
            this.lasMainGroups = response.data;
            if (this.lasGroups.length) {
                this.lasGroupsOrStudents = 'las';
            }
        });

        this.axios.get(this.routes.getStudents()).then(
            (response) => {
                this.students = response.data;
            },
            (error) => {
                this.alert.ajaxError(error);
            },
        );

        this.isLoading = false;
    },

    computed: {
        groupsExist() {
            return !!this.lasGroups.length || !!this.lasMainGroups.length;
        },
    },

    methods: {
        updateSelectedGroups(lasGroups) {
            this.groups.las_groups = [...lasGroups];
            this.$emit('input', this.groups);
        },

        updateSelectedMainGroups(mainGroups) {
            this.groups.main_groups = [...mainGroups];
            this.$emit('input', this.groups);
        },

        updateSelectedStudents(students) {
            this.groups.students = [...students];
            this.$emit('input', this.groups);
        },

        clearSelectedGroupAndStudents(selected) {
            if (selected === 'las') {
                this.groups.students = [];
                this.$emit('input', this.groups);
            } else {
                this.groups.main_groups = [];
                this.groups.las_groups = [];
                this.$emit('input', this.groups);
            }
        },

        async checkForErrors() {
            this.hasError = false;

            if (this.lasGroupsOrStudents === 'las') {
                if (!this.groups.las_groups.length && !this.groups.main_groups.length) {
                    this.hasError = true;
                }
            } else {
                if (!this.groups.students.length) {
                    this.hasError = true;
                }
            }

            if (this.hasError) {
                $('.main-content').animate({ scrollTop: 0 }, 500);
            }

            return this.hasError;
        },
    },
};
</script>

<style scoped lang="scss">
.students-groups-choice-group,
.groups-picklist {
    margin-bottom: $grid-gutter-width;
}
</style>
